export enum Routes {
  Hash = '#',
  Login = '/',
  Vault = '/vault',
  VaultPreview = '/vault/preview/:documentId',
  VaultPending = '/vault/pending',
  Contacts = '/contacts',
  Certification = '/certification/:documentId',
  VaultTransfer = '/vault-transfer',
  Dossiers = '/dossiers',
  Dossier = '/dossiers/:dossierId',
  DossierPreview = '/dossiers/:dossierId/preview/:documentId',

  Trash = '/trash',
  HistoryLog = '/history-log',
  Profile = '/profile',
  ProfileMailNotifications = '/profile/emailNotifications',

  HelpInfo = '/help/info',
  HelpReportProblem = '/help/report-problem',

  Debug = '/debug',
}
